import { IRailwayToursList, IRailwayToursListItem } from '../types';

const hotelOffersTariffsStore: IRailwayToursList = {
    railwayTourItems: [],
};

export default {
    namespaced: true,
    state: hotelOffersTariffsStore,
    mutations: {
        railwayToursListChanged(state: IRailwayToursList, value: IRailwayToursListItem[]): void {
            state.railwayTourItems = value;
        },
    },
};